// extracted by mini-css-extract-plugin
export var avatarContainer = "_c9-0";
export var avatarTypingWave = "_c9-i";
export var gray = "_c9-f";
export var green = "_c9-c";
export var icon = "_c9-9";
export var image = "_c9-1";
export var lg = "_c9-6";
export var md = "_c9-5";
export var presenceDot = "_c9-b";
export var red = "_c9-d";
export var sm = "_c9-4";
export var status = "_c9-a";
export var typingDot = "_c9-h";
export var typingPill = "_c9-g";
export var xl = "_c9-7";
export var xs = "_c9-3";
export var xxl = "_c9-8";
export var xxs = "_c9-2";
export var yellow = "_c9-e";